module.exports = __webpack_public_path__ + "fonts/700-normal-cyrillic.087cff9.woff2";